import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HttpService } from "../../services/HttpService";
import Store from "..";
import { buildParamsUrl } from "../../utils/helpers";

const initialState = {
  surveysReportList: [],
  adminSurveysReportList: [],
  farmacia: "",
  pageIndex: 1,
  adminPageIndex: 1,
  pageTotal: 0,
  itemsPerPage: Number(process.env.REACT_APP_PAGE_LIST) || 5,
  orderBy: "name",
  orderAs: "asc",
  filterParams: {},
  apiError: "",
};

/**
 * Filter survey report
 */
export const getSurveyReport = () => async (dispatch: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    const { surveysReport } = Store.getState();
    const { orderAs, itemsPerPage, orderBy, pageIndex, filterParams } =
      surveysReport;

    const params = buildParamsUrl({
      ...filterParams,
      orderBy,
      orderAs,
      itemsPerPage,
      page: pageIndex,
    });

    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/report/survey-answers?${params}`
    );

    if (list.data) {
      const pageTotal = Math.ceil(Number(list.data.totalItems) / itemsPerPage);
      dispatch(updateSurveysReport(list.data.result));
      dispatch(updatePageTotal(pageTotal));
      dispatch(updateServerError(""));
    }
  } catch (e: any) {
    dispatch(updateServerError(e.response.data.result));
  }
};

/**
 * Filter admin survey report
 */
export const getAdminSurveyReport = () => async (dispatch: any) => {
  try {
    const { surveysReport } = Store.getState();
    const { orderAs, itemsPerPage, orderBy, adminPageIndex, filterParams } =
      surveysReport;

    const params = buildParamsUrl({
      ...filterParams,
      orderBy,
      orderAs,
      itemsPerPage,
      page: adminPageIndex,
    });

    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/event/report/survey-events?${params}`
    );

    if (list.data) {
      const pageTotal = Math.ceil(Number(list.data.totalItems) / itemsPerPage);
      dispatch(updateAdminSurveysReport(list.data.result));
      dispatch(updatePageTotal(pageTotal));
      dispatch(updateServerError(""));
    }
  } catch (e: any) {
    dispatch(updateServerError(e.response.data.result));
  }
};

/**
 * update pagination number
 */
export const updatePageIndex = (pageIndex: Number) => async (dispatch: any) => {
  try {
    dispatch(updatePage(pageIndex));
  } catch (e) {
    console.log("update page index:", e);
  }
};

/**
 * update admin main survey report page number
 */
export const adminSurveyTablePageIndex =
  (pageIndex: Number) => async (dispatch: any) => {
    try {
      dispatch(updateAdminPage(pageIndex));
    } catch (e) {
      console.log("update page index:", e);
    }
  };

/**
 * update survey history table pagination  number
 */
export const updateSurveyHistoryPageIndex =
  (pageIndex: Number) => async (dispatch: any) => {
    try {
      dispatch(updatePage(pageIndex));
    } catch (e) {
      console.log("update search value:", e);
    }
  };

/**
 * Get survey campaign dropdown options
 */
export const getCampaignOption = () => async (dispatch: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/survey-campaigns`
    );
    if (list.data) {
      return list.data;
    }
  } catch (e) {
    console.log("fetch campaign options:", e);
  }
};

/**
 * Get survey dropdown options
 */
export const getSurveyOption = () => async (dispatch: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/surveyList`
    );
    if (list.data) {
      return list.data.result;
    }
  } catch (e) {
    console.log("fetch survey options:", e);
  }
};

/**
 * Get regional-code dropdown options
 */
export const getRegionalCodesOption = () => async (dispatch: any) => {
  try {
    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/federfarma/regional-codes`
    );
    if (list.data) {
      return list.data;
    }
  } catch (e) {
    console.log("fetch survey options:", e);
  }
};

/**
 * Get campagna dropdown options
 */
export const getSurveyCampaignOption = () => async (dispatch: any) => {
  try {
    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/federfarma/survey-campaigns`
    );
    if (list.data) {
      return list.data;
    }
  } catch (e) {
    console.log("fetch survey options:", e);
  }
};

/**
 * Get district dropdown options
 */
export const getDistrictOption = () => async (dispatch: any) => {
  try {
    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/brand/districts`
    );
    if (list.data) {
      return list.data;
    }
  } catch (e) {
    console.log("fetch district options:", e);
  }
};

/**
 * Get city dropdown options
 */
export const getCityOption = () => async (dispatch: any) => {
  try {
    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/brand/cities`
    );
    if (list.data) {
      return list.data;
    }
  } catch (e) {
    console.log("fetch district options:", e);
  }
};

/**
 * Get survey-slugs dropdown options
 */
export const getSurveySlugOption = () => async (dispatch: any) => {
  try {
    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/federfarma/surveys`
    );
    if (list.data) {
      return list.data;
    }
  } catch (e) {
    console.log("fetch district options:", e);
  }
};

/**
 * Get ats-farmacia dropdown options
 */
export const getATSFarmaciaOption = () => async (dispatch: any) => {
  try {
    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/brand/ats-codes`
    );
    if (list.data) {
      return list.data;
    }
  } catch (e) {
    console.log("fetch district options:", e);
  }
};

/**
 * Get farmacia detail by regional code
 */
export const getFarmaciaByRegionalCode =
  (code: any) => async (dispatch: any) => {
    try {
      const list = await HttpService.get(
        `${process.env.REACT_APP_API}/t4event/api/v01/federfarma/pharmacy-information/${code}`
      );
      if (list.data) {
        dispatch(updateFarmacia(list.data));
      }
    } catch (e) {
      console.log("Get Farmacia:", e);
    }
  };

/**
 * update filter params
 */
export const updateFilterParams =
  (params: any, isAdmin: boolean) => async (dispatch: any) => {
    try {
      dispatch(updateParams(params));
      if (isAdmin) {
        dispatch(getAdminSurveyReport());
      } else {
        dispatch(getSurveyReport());
      }
    } catch (e) {
      console.log("update filter params:", e);
    }
  };

/**
 * update api error
 */
export const updateError = () => async (dispatch: any) => {
  try {
    dispatch(updateServerError(""));
  } catch (e) {
    console.log("reset api error:", e);
  }
};

/**
 * returns fileName.
 */
export const getReportFileName =
  (type: string, filters: any) => async (dispatch: any) => {
    try {
      const params = buildParamsUrl({
        ...filters,
      });
      const list = await HttpService.get(
        `${process.env.REACT_APP_API}/t4event/api/v01/federfarma/export/surveys/${type}?${params}`
      );
      if (list.data) {
        return list.data.fileName;
      }
    } catch (e) {
      console.log("export report:", e);
    }
  };


const surveyReportReducer = createSlice({
  name: "surveysReport",
  initialState,
  reducers: {
    updateSurveysReport(state, action: PayloadAction<any>) {
      state.surveysReportList = action.payload;
    },
    updateAdminSurveysReport(state, action: PayloadAction<any>) {
      state.adminSurveysReportList = action.payload;
    },
    updatePageTotal(state, action: PayloadAction<any>) {
      state.pageTotal = action.payload;
    },
    updatePage(state, action: PayloadAction<any>) {
      state.pageIndex = action.payload;
    },
    updateAdminPage(state, action: PayloadAction<any>) {
      state.adminPageIndex = action.payload;
    },
    updateOrder(state, action: PayloadAction<any>) {
      state.orderBy = action.payload;
    },
    updateOrderAs(state, action: PayloadAction<any>) {
      state.orderAs = action.payload;
    },
    updateParams(state, action: PayloadAction<any>) {
      state.filterParams = action.payload;
    },
    updateServerError(state, action: PayloadAction<any>) {
      state.apiError = action.payload;
    },
    updateFarmacia(state, action: PayloadAction<any>) {
      state.farmacia = action.payload;
    },
  },
});

export const {
  updatePageTotal,
  updateOrder,
  updateOrderAs,
  updatePage,
  updateAdminPage,
  updateParams,
  updateServerError,
  updateSurveysReport,
  updateAdminSurveysReport,
  updateFarmacia,
} = surveyReportReducer.actions;

export default surveyReportReducer.reducer;
